import React, { FC } from 'react';

import { SolicitacaoAtividade } from '../SolicitacaoAtividade';
import { Comentario } from 'model/solicitacao/comentario/Comentario';
import { SolicitacaoDetalhada } from 'model/solicitacao/SolicitacaoDetalhada';
import { ListaAnexosSolicitacao } from 'view/section/Anexos/components/ListaAnexosSolicitacao';
import { TextoMarkdown } from 'view/component/Tipografia/Texto';
import { SRText } from 'view/component/ScreenReaderText/ScreenReaderText';
import { RotulosTipoComentario } from '../RotulosTipoComentario';


interface SolicitacaoComentarioProps {
  comentario: Comentario
  solicitacao: SolicitacaoDetalhada
}

export const SolicitacaoComentario: FC<SolicitacaoComentarioProps> = ({comentario, solicitacao}) => {
  const pessoa = {idInstitucional: comentario.idPessoa, nome: comentario.nomePessoa}

  const hasAnexos = comentario?.anexos.length > 0;

  return <SolicitacaoAtividade
    id={comentario.id}
    solicitacao={solicitacao}
    pessoa={pessoa}
    dataCadastro={comentario.dataCriacao}
    prefixoLink="comentario"
    rotulos={<RotulosTipoComentario tipoComentario={comentario.tipoComentario} />}>
    <TextoMarkdown>{comentario?.mensagem ?? ''}</TextoMarkdown>

    { hasAnexos &&
      <aside>
        <header>
          <SRText>Anexos</SRText>
        </header>
        <ListaAnexosSolicitacao anexos={comentario?.anexos} />
      </aside>
    }

  </SolicitacaoAtividade>
}
